import packageJson from "../../package.json";

export const getAppVersion = () => {
  return packageJson.version;
};

export const getAppName = () => {
  return packageJson.name;
};

// Log app info on module load
console.log(`🚀 ${getAppName()} v${getAppVersion()}`);

export const logAppInfo = () => {
  console.log(`🚀 ${getAppName()} v${getAppVersion()}`);
};
